// i18n area 'common' — locale et-EE (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/common.et-EE.meta.json.
import type { enUS } from './common'

export const etEE: typeof enUS = {
  nav: {
    home: 'Avaleht',
    vms: 'Virtuaalmasinad',
    templates: "Template'id",
    importVms: 'Impordi VM-id',
    containers: 'Konteinerid',
    containersApps: 'Rakendused',
    containersPods: 'Podid',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'OCI-tõmmised',
    containersOciRegistries: "OCI-registry'd",
    containersCtTemplates: "CT-template'id",
    networkServices: 'Võrguteenused',
    firewall: 'Tulemüür',
    checkpoints: 'Checkpointid',
    backup: 'Backup',
    monitoring: 'Seire',
    cluster: 'Klaster',
    clusterSettings: 'Üldised seaded',
    clusterNodes: 'Sõlmed',
    clusterDevices: 'USB- ja PCIe-ressursid',
    clusterFederation: 'Föderatsioon',
    network: 'Võrk',
    overlayNetworks: 'Overlay-võrgud',
    fabric: 'Fabric',
    ipam: 'IPAM',
    storage: 'Storage',
    data: 'Andmed',
    storages: "Storage'id",
    hci: 'Hüperkonvergents',
    ceph: 'Ceph',
    system: 'Süsteem',
    tasks: 'Taskid',
    events: 'Sündmused',
    audit: 'Audit',
    diagnostics: 'Diagnostika',
    notifications: 'Teavitused',
    proximity: 'TVirt Proximity',
    users: 'Kasutajad ja grupid',
    groups: 'Grupid',
    mfa: 'MFA',
    realms: 'Realmid ja SSO',
    rbac: 'Rollid ja õigused',
    credentials: 'Mandaadid',
    scopes: "Scope'id",
    tags: 'Sildid',
    explorer: 'Sirvi',
    licensing: 'Litsents',
    information: 'Teave'
  },
  mode: {
    light: 'Hele',
    dark: 'Tume',
    system: 'Süsteem',
    tooltip: 'Teema'
  },
  language: {
    tooltip: 'Keel'
  },
  langRegion: {
    europe: 'Euroopa',
    northAmerica: 'Põhja-Ameerika',
    southAmerica: 'Lõuna-Ameerika',
    asia: 'Aasia'
  },
  notFound: {
    title: 'Lehte ei leitud',
    body: 'See aadress ei vasta ühelegi TVirti lehele — see võis uuendusega mujale liikuda või on link vana.',
    backHome: 'Tagasi avalehele'
  },
  scopeBrowser: {
    title: 'Scope',
    all: 'Kogu klaster',
    noChildren: "Siin pole ühtegi alam-scope'i",
    recursive: 'Kaasa järglased',
    collapse: "Ahenda scope'i paneel",
    openPicker: 'Ava scope-valija',
    up: 'Liigu tase ülespoole',
    countTooltip: "{direct} selles scope'is · {total} koos järglastega"
  },
  search: {
    tooltip: 'Otsi (⌘K)',
    placeholder: "Otsi VM-e, võrke, storage'it…",
    empty: 'Tulemusi pole',
    groups: {
      recent: 'Hiljutised',
      shortcuts: 'Otseteed',
      actions: 'Toimingud',
      goTo: 'Mine'
    },
    kind: {
      catalog: 'Kataloog',
      scope: 'Scope',
      node: 'Sõlm'
    },
    footer: {
      navigate: 'liigu',
      open: 'ava',
      close: 'sulge'
    },
    actions: {
      createVm: 'Loo VM…',
      uploadIso: 'Laadi ISO üles…',
      clusterSettings: 'Klastri seaded',
      consoleOf: 'Mine {name} konsooli'
    }
  },
  stub: {
    containersSummary: "Rakendused ja süsteemikonteinerid (CT) koos oma OCI-tõmmiste, registry'de ja template'itega — hallatavad sinu VM-ide kõrval.",
    sectionSummary_vms: "Virtuaalmasinad ja nende template'id — elutsükkel, snapshot'id, migratsioon ja konsool.",
    sectionSummary_storages: "Storage'id, kus elavad VM-ide kettad, tõmmised ja metaandmed.",
    sectionSummary_catalogs: "Klastri failiartefaktide kodu: ISO-tõmmised, CT- ja VM-template'id ning OCI-arhiivid, kataloogidesse korrastatuna.",
    sectionSummary_overlay: 'VXLAN-overlay-võrgud klastri sõlmede vahel.',
    sectionSummary_fabric: 'Füüsilise võrgu inventuur — switchid, pordid, LAGG-id ja loogilised võrgud.',
    sectionSummary_ipam: 'Fabric- ja overlay-võrkudest tuletatud aadressistik: kes millist aadressi hoiab.',
    sectionSummary_services: 'Võrguregistrist tuletatud DHCP- ja DNS-serverid.',
    sectionSummary_ceph: 'TVirti sõlmedes hallatavad Ceph-klastrid.',
    sectionSummary_hci: 'Hüperkonvergentsed storage-tehnoloogiad TVirti sõlmedes.',
    sectionSummary_cluster: 'Sõlmed, liikmesus ja klastri seaded.',
    containers: 'Süsteemikonteinerid on roadmapil — see jaotis hakkab neid majutama.',
    containersApps: 'Konteineritesse pakitud rakendused on roadmapil — see ala hakkab neid majutama.',
    containersPods: 'Podid koondavad konteinereid, mis jagavad võrku ja mahtusid — eksemplarid on rakendused.',
    containersCt: 'Süsteemikonteinerid (CT) on roadmapil — see ala hakkab neid majutama.',
    multiscsi: 'TVStor MultiSCSI on roadmapil — see ala hakkab seda majutama.',
    clusterFederation: 'TVirti klastrite vaheline föderatsioon on roadmapil — see ala hakkab seda majutama.',
    containersOciImages: 'OCI-tõmmised on roadmapil — see ala hakkab neid majutama.',
    containersOciRegistries: "OCI-registry'd on roadmapil — see ala hakkab neid majutama.",
    containersCtTemplates: "CT-template'id on roadmapil — see ala hakkab neid majutama.",
    importVms: 'ESXi ja Proxmoxi importerid jõuavad siia: külalismasinate konverteerimine ja hulgimigratsioon TVirti sisse.',
    backup: 'Sisseehitatud backup jõuab kohale versiooniga 6.2: dedupleeritud content-addressed repod, CBT-inkrementaalid, muutumatuse aknad ja repo-to-repo replikatsioon.',
    monitoring: 'Klastriülesed ressursikonkurentsi dashboardid (cpu.ready, PSI-surve, sisseehitatud alarmid) on tulekul — täna elavad samad mõõdikud iga VM-i üksikasjades.'
  },
  home: {
    welcome: 'Oled sisse loginud kasutajaga: {name}',
    subtitle: 'Siin on sinu TVirti klaster ühe pilguga.',
    loadError: 'Ülevaate laadimine ebaõnnestus — kas TVirti backend on kättesaadav?',
    health: {
      ok: 'Kõik korras',
      warning: 'Tähelepanu',
      critical: 'Kriitilised probleemid'
    },
    reason: {
      'node-down': '{subject} on välja lülitatud',
      'node-stale': '{subject} pole end mõnda aega kuuldavale andnud',
      'node-maintenance': '{subject} on hoolduses',
      'tasks-failed': {
        one: '{n} nurjunud task viimase 24 tunni jooksul',
        other: '{n} nurjunud taski viimase 24 tunni jooksul'
      },
      'storage-degraded': 'storage {subject} on degradeerunud',
      'storage-error': 'storage {subject} on veaolekus',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': 'klastri store pole kättesaadav',
      'license-absent': 'litsentsi pole — uued VM-id ei saa käivituda',
      'license-expired': 'litsents on aegunud — uued VM-id ei saa käivituda',
      'license-exceeded': 'litsentsi piir on ületatud — uued VM-id ei saa käivituda',
      'failover-reserve-eroded': 'failover-reserv on peaaegu ära kulutatud',
      'failover-reserve-exhausted': 'failover-reserv on otsas — uued VM-id ei saa käivituda',

      'oci-cache-nearly-full': 'OCI vahemälu {subject} peal on peaaegu täis — digest’id eemaldatakse käsitsi',
      'oci-cache-full': 'OCI vahemälu {subject} peal on täis — ükski pull ei õnnestu, kuni digest’e ei eemaldata',
      'config-replica-empty': 'konfiguratsiooni koopia {subject} peal on TÜHI — sõlmel pole klastri konfiguratsiooni, kuni replikatsioon õnnestub',
      'config-replica-stalled': 'konfiguratsiooni replikatsioon {subject} peal seisab — kohalik koopia jääb klastri konfiguratsioonist maha'
    },
    staleChip: 'Andmed pole värsked',
    staleAsOf: 'viimane replikatsioon {time}',
    zone: {
      nodes: 'Sõlmed',
      failoverReserve: 'Failover-reserv',
      capacity: 'Maht',
      workload: 'Töökoormus',
      protection: 'Kaitse',
      activity: 'Hiljutine tegevus'
    },

    // Failover-reservi tsoon (admission control N+1, task #133b).
    reserve: {
      state: {
        ok: 'Reserv on terve',
        eroded: 'Reserv on peaaegu kulutatud',
        exhausted: 'Reserv on otsas',
        unknown: 'Reserv on teadmata'
      },
      tolerate: {
        one: 'talub {n} sõlme kaotust',
        other: 'talub {n} sõlme kaotust'
      },
      usedOf: '{used} / {allowed} GiB kasutuses',
      keepFree: '{n} GiB hoitakse failoveri jaoks vabana',
      expendable: 'sellest {n} ohverdatavad töös',
      headroom: 'käivitada saab veel {n} GiB',
      short: 'reservist on puudu {n} GiB — uued VM-id ei saa käivituda',
      hp: {
        usedOf: '{size} leheküljed — kasutusel: {used} / {allowed}',
        keepFree: 'failoveri jaoks vabana hoitud: {keep}',
        headroom: 'veel käivitatavad: {n}',
        short: 'reservist puudu: {n} — uued hiiglaslike lehekülgedega VM-id ei saa käivituda'
      },
      worstCase: 'halvim juhtum: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Ükski sõlm pole veel oma mälu deklareerinud — reservi ei saa arvutada ja ühtegi käivitust tagasi ei lükata.',
      reason: {
        attestedDown: 'atesteeritud seiskunuks',
        maintenance: 'hoolduses',
        unreachable: 'kättesaamatu',
        capacityUnknown: 'mälu pole deklareeritud'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: '{cores} tuuma / {threads} lõime',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} aktiivne VM',
        other: '{n} aktiivset VM-i'
      },
      activeVmsUnknown: 'Aktiivsed VM-id teadmata',
      lastSeen: 'nähtud {time}',
      neverSeen: 'pole kunagi nähtud',
      down: 'Välja lülitatud',
      maintenance: 'Hooldus',
      stale: 'Kättesaamatu'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: '{n} GiB provisioneeritud',
      reserve: 'reserv {n} GiB',
      unobserved: 'mahtu pole veel tuvastatud',
      empty: "Ühtegi storage'it veel pole"
    },
    workload: {
      vms: 'Virtuaalmasinad',
      apps: 'Rakendused',
      services: 'Võrguteenused',
      empty: 'Veel mitte ühtegi',
      phasesUnknown: 'jaotus faaside kaupa pole saadaval'
    },
    protection: {
      none: 'Ühtegi varunduse sihtkohta pole seadistatud — kaitse oma konfiguratsiooni.',
      configure: 'Seadista checkpointid',
      noRuns: 'Ühtegi checkpointi pole veel loodud.',
      last: 'Viimane checkpoint',
      onTarget: 'sihtkohas {target}',
      viewAll: 'Checkpointid'
    },
    activity: {
      empty: 'Hiljutine tegevus puudub',
      failed24: {
        one: '{n} nurjunud 24 tunniga',
        other: '{n} nurjunud 24 tunniga'
      },
      viewAll: 'Kuva kõik taskid'
    }
  },
  notes: {
    title: 'Märkmed',
    tabEdit: 'Muuda',
    tabPreview: 'Eelvaade',
    placeholder: 'Operaatori vabad märkmed — Markdown renderdatakse eelvaates',
    empty: 'Märkmeid pole',
    tooLarge: 'Märkmed ületavad 64 KiB piiri',
    saveError: 'Märkmete salvestamine ebaõnnestus'
  },
  common: {
    contractError: 'Backendi vastus sisaldab väärtust, mida see liides ei tunne: {field}={value} — uuenda veebiliides backendi versioonile.',
    contractErrorItems: '{count} selle loendi objekti ei suuda see liides lugeda ({field}={value}) ja neid ei kuvata.',
    staleHint: 'Store pole kättesaadav — see on selle sõlme konfiguratsioonikoopia; sõlmepargi olek on teadmata.',
    staleStateAge: 'olek seisuga {time}',
    staleStateNever: "olekut pole store'ist kunagi saadud: näed ainult selle sõlme enda vaatlusi",
    staleStateTooltip: "Klastri store pole kättesaadav: vaadeldud olek (faas, sõlm, agent) tuleb selle sõlme olekukoopiast ja pärineb viimasest õnnestunud lugemisest store'ist — see võib olla aegunud.",
    noPermission: 'Sul pole selleks toiminguks õigust',
    actionStillRunning: 'Toiming on veel pooleli — tulemus pole veel teada',
    staleWrite: 'Keegi teine muutis seda objekti, kui sa seda redigeerisid — midagi ei kirjutatud. Laadi uuesti ja korda muudatust värskel seisul.',
    staleReload: 'Laadi uuesti',
    preview: 'Eelvaade',
    previewTitle: 'Tulemuse eelvaade',
    previewNothingWritten: 'Simuleeritud serveris — midagi ei kirjutatud.',
    previewChanged: 'Esile tõstetud: väärtused, mis muutuksid.'
  },
  context: {
    copySelection: 'Kopeeri valitud tekst'
  },
  crud: {
    create: 'Loo',
    viewDetails: 'Vaata üksikasju',
    viewOrEdit: 'Vaata või muuda',
    selected: 'valitud',
    viewUsingVms: 'Vaata ressurssi kasutavaid VM-e',
    clearSelection: 'Tühista valik',
    deleteSelected: 'Kustuta valitud',
    bulkConfirmBody: {
      one: 'Kas kustutada {count} valitud element? Kui see on kaitstud, märgitakse see ära ja säilitatakse.',
      other: 'Kas kustutada {count} valitud elementi? Kaitstud elemendid märgitakse ära ja säilitatakse.'
    },
    bulkDeleted: 'kustutatud',
    bulkRefused: 'tagasi lükatud',
    fieldId: 'ID',
    createdAt: 'Loodud',
    updatedAt: 'Uuendatud',
    immutableField: 'Fikseeritud loomisel — contract ei luba seda muuta',
    immutableScope: 'Scope määratakse loomisel; mõned ressursid liiguvad eraldi toiminguga',
    observedField: 'Vaadeldud olek — platvormi teatatud, ei ole muudetav'
  }
}
